import { getData } from "../../api";

// Blog
// export const mediaSpace = async (id,premium) => {
//     try {
//         const url=getData(`/without-login/studio/all-studio?category_id=${id}`)
//         if(premium){
//             url+`premium=${premium}`
//         }
//         return await url;
//     } catch (error) {
//         console.log(error);
//     }
// };

export const mediaSpace = async (
  currentPage,
  id,
  premium,
  location,
  price,
  rating,
  city_id
) => {
  try {
    let url = `/without-login/services/all-services?page=${currentPage}&category_id=${id}`;
    // let url = `/without-login/services/all-services?category_id=${id}`;

    if (location) {
      url += `&location=${location.location}`;
    }

    // if (premium) {
    //   url += `&premium=${premium}`;
    // }

    if (price) {
      url += `&price=${price.price || price.priceRange.max}`;
    }

    if (rating) {
      url += `&rating=${rating.rating}`;
    }


    
    if (city_id) {
      url += `&city_id=${city_id != undefined ? city_id : ""}`;
    }

    const response = await getData(url);
    return response;
  } catch (error) {
    console.error("Error fetching media space data:", error);
    throw error; // Re-throw the error for the calling function to handle it
  }
};


export const mediaSpaceVendor = async (
  currentPage,
  id,
  premium,
  location,
  price,
  rating,
  city_id
) => {
  try {
    // let url = `/without-login/studio/all-studio?page=${currentPage}&category_id=${id}`;
    let url = `/without-login/services/all-services?vender_id=${id}`;

    if (location.location != undefined) {
      url += `&location=${location.location}`;
    }

    // if (premium) {
    //   url += `&premium=${premium}`;
    // }

    if (price) {
      url += `&price=${price.price || price.priceRange.max}`;
    }

    if (rating) {
      url += `&rating=${rating.rating}`;
    }

    if (city_id) {
      url += `&city_id=${city_id != undefined ? city_id : ""}`;
    }

    const response = await getData(url);
    return response;
  } catch (error) {
    console.error("Error fetching media space data:", error);
    throw error; // Re-throw the error for the calling function to handle it
  }
};

export const mediaSpaceDetails = async (id) => {
  try {
    // return await getData(`/without-login/studio/${id}`);
    return await getData(`/without-login/services/${id}`);
  } catch (error) {
    console.log(error);
  }
};

// Faq

export const faqCategory = async (id) => {
  try {
    return await getData(`/faq`);
  } catch (error) {
    console.log(error);
  }
};

export const FaqCategoryData = async (id) => {
  try {
    return await getData(`/faq`);
  } catch (error) {
    console.log(error);
  }
};

export const FaqData = async (id) => {
  try {
    return await getData(`/faq/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const FaqFAqData = async (id) => {
  try {
    return await getData(`/faq/all`);
  } catch (error) {
    console.log(error);
  }
};
